import dayjs from 'dayjs'

export const getColumnDefs = () => [
  {
    field: 'product',
    enableRowGroup: true,
    enablePivot: true,
    menuTabs: ['filterMenuTab'],
  },
  {
    field: 'terminal',
    enableRowGroup: true,
    enablePivot: true,
    menuTabs: ['filterMenuTab'],
  },
  {
    field: 'supply_zone',
    headerName: 'Supply Zone',
    enableRowGroup: true,
    enablePivot: true,
    menuTabs: ['filterMenuTab'],
  },
  {
    field: 'supplier',
    enableRowGroup: true,
    enablePivot: true,
    menuTabs: ['filterMenuTab'],
  },
  {
    field: 'price_type',
    headerName: 'Price Type',
    enableRowGroup: true,
    enablePivot: true,
    menuTabs: ['filterMenuTab'],
    cellRenderer: 'textCell',
    cellRendererParams: { toUppercase: true },
  },

  {
    field: 'contract',
    enableRowGroup: true,
    enablePivot: true,
    menuTabs: ['filterMenuTab'],
    cellRenderer: 'tagCell',
    cellRendererParams: { tagTheme: { theme1: true }, weight: 'bold' },
  },
  {
    field: 'effective_from',
    headerName: 'Effective From',
    valueGetter: (params) => dayjs(params.data.effective_from).format('MM/DD/YYYY h:mm A'),
    menuTabs: [],
  },
  {
    field: 'effective_to',
    headerName: 'Effective To',
    valueGetter: (params) => dayjs(params.data.effective_to).format('MM/DD/YYYY h:mm A'),
    menuTabs: [],
  },
  {
    field: 'loaded',
    enableValue: true,
    cellRenderer: 'numberCell',
    cellRendererParams: { weight: 'bold', align: 'right' },
    menuTabs: [],
  },
  {
    field: 'scheduled',
    enableValue: true,
    cellRenderer: 'numberCell',
    cellRendererParams: { weight: 'bold', align: 'right' },
    menuTabs: [],
  },
  {
    field: 'planned',
    enableValue: true,
    cellRenderer: 'numberCell',
    cellRendererParams: { weight: 'bold', align: 'right' },
    menuTabs: [],
  },
  {
    field: 'status',
    minWidth: 150,
    menuTabs: ['filterMenuTab'],
    cellRenderer: 'statusCR',
  },
]
